<template>
    <div class="csat-choice">
        <div
            v-for="option in options"
            :key="option.id"
            class="csat-choice__item"
            :class="{ 'csat-choice__item--selected': option.isSelected }"
            :style="option.isSelected ? { borderColor: option.color } : {}"
            @click="selectOption(option)"
        >
            <v-icon class="csat-choice__icon" size="50" :color="option.color">{{ option.icon }}</v-icon>
            <label :for="`option-${option.id}`" class="csat-choice__label">{{ option.name }}</label>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                default: null
            },
            items: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                options: [],
                selectedOptionId: null
            }
        },
        watch: {
            items: {
                handler(newOptions) {
                    this.options = Array.isArray(newOptions) ? newOptions.map(x => ({ ...x })) : []
                    this.selectedOptionId = null
                },
                immediate: true,
                deep: true
            }
        },
        methods: {
            selectOption(selectedOption) {
                this.options = this.options.map(x => ({
                    ...x,
                    isSelected: x.id === selectedOption.id
                }))
                this.selectedOptionId = selectedOption.id

                this.$emit('input', this.selectedOptionId)
            }
        }
    }
</script>

<style scoped>
    .csat-choice {
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: flex-start;
        gap: 4px;
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
    }

    .csat-choice__item {
        flex: 1 1 0;
        min-width: 0;
        text-align: center;
        cursor: pointer;
        padding: 4px 2px;
        border: 1px solid transparent;
        border-radius: 10px;
    }

    .csat-choice__item--selected {
        border-style: solid;
    }

    .csat-choice__label {
        display: block;
        margin-top: 5px;
        font-size: 14px;
        color: #555;
        font-weight: 700;
        line-height: 1.2;
        word-break: break-word;
    }

    @media only screen and (max-width: 600px) {
        .csat-choice {
            gap: 2px;
        }

        .csat-choice__item {
            padding: 2px 1px;
        }

        .csat-choice__icon {
            font-size: 36px !important;
            width: 36px !important;
            height: 36px !important;
        }

        .csat-choice__label {
            font-size: 10px;
            margin-top: 2px;
        }
    }

    @media only screen and (max-width: 380px) {
        .csat-choice__icon {
            font-size: 28px !important;
            width: 28px !important;
            height: 28px !important;
        }

        .csat-choice__label {
            font-size: 9px;
        }
    }
</style>
